import types from '../actions/actionTypes';

export function selectedSubreddit(state = 'reactjs', action) { 
  switch (action.type) { 
    case types.SELECT_SUBREDDIT: 
      return action.subreddit 
    default: 
      return state 
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/reducers/selectedSubreddit.js